import { useParams } from '@tanstack/react-router';

import { Queries } from '@/queries/Queries.ts';

export const usePatientIdFromURL = () => {
  return useParams({
    from: '/patients/$id',
    select: (params: { id: string }) => params.id,
  });
};

export const usePatientFromURL = () => {
  const patientId = usePatientIdFromURL();
  return Queries.practitioner.usePatient(patientId);
};
